import React, { useEffect, useState } from "react";
import SidebarCollection from "./SidebarCollection";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import { getConfig, searchAPI } from "../../apis";
import Table from "./Table";
import DeleteBookmark from "./popup/DeleteBookmark";
import { getFormattedDate } from "../../functions/time";
import { logEvent } from "../../functions/amplitude";
import CustomLoader from "../../components/loader";
import ShareBookmark from "./popup/ShareBookmark";
import SharedList from "./popup/SharedList";
import Datepicker from "../../components/datepicker/Datepicker";
import RenameCollection from "./popup/RenameCollection";
import NewBookmark from "../NewsCategoryPage/NewBookmark";
import CustomSummarize from "../NewsPage/uis/SectionNews/CustomSummarize";
import Summarize from "./Summarize";
import UpdateSummary from "./popup/UpdateSummarize";
import PopupSave from "../NewsPage/uis/SectionNews/PopupSave";
import PopupCitation from "./popup/PopupCitation";
import CustomBookmark from "./popup/CustomBookmark";
import TopHeader from "./TopHeader";
import BottomHeader from "./BottomHeader";
import { setCitationPopup } from "../../redux/features/dataSlice";
import { useDispatch } from "react-redux";
import { axiosInstance } from "../../functions/axios";
import useDocumentTypes from "../../hooks/useDocumentTypes";

const SavedPage = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const searchUrlParams = searchParams.get("search")
    ? searchParams.get("search")
    : "";

  const [sidebarColActive, setSidebarColActive] = useState(false);
  const [bookmarks, setBookmarks] = useState([]);
  const [bookmark, setBookmark] = useState("");
  const [summary, setSummary] = useState("");
  const [loading, setLoading] = useState(true);
  const [collections, setCollections] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [deletePopup, setDeletePopup] = useState(false);
  const [renamePopup, setRenamePopup] = useState(false);
  const [desc, setDesc] = useState("");
  const [showSummarizePopup, setShowSummarizePopup] = useState(false);
  const [search, setSearch] = useState(searchUrlParams);

  const [sharePopup, setSharePopup] = useState(false);
  const [userPopup, setUserPopup] = useState(false);
  const [parent, setParent] = useState(0);
  const [headerParams, setHeaderParams] = useState({ isShared_ysn: false });
  const [isDescExternal, setIsDescExternal] = useState(false);
  const [selectedCollection, setselectedCollection] = useState();
  const [darkBackground, setDarkBackground] = useState(false);
  const [summaryText, setSummaryText] = useState("");
  const [id, setId] = useState("");
  const [citationAvailable, setCitationAvailable] = useState(false);
  const [saveBookmarkPopup, setSaveBookmarkPopup] = useState(false);
  const [summarizePopupNa, setSummarizePopupNa] = useState(false);
  const [articleData, setArticleData] = useState({});
  const [citation, setCitation] = useState("");
  const [customBookmarkPopup, setCustomBookmarkPopup] = useState(false);
  const [collectionIdArray, setCollectionIdArray] = useState([]);
  const [parentCollectionIds, setParentCollectionIds] = useState([]);
  const [searchedBookmark, setSearchedBookmark] = useState({});
  const [subNewFolder, setSubNewFolder] = useState(false);
  const [searchFromBookmarks, setSearchFromBookmarks] = useState("");
  const [filteredBookmarks, setFilteredBookmarks] = useState([]);

  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { user } = useSelector((state) => state.auth);
  useDocumentTypes(user.userId);

  const {
    datePicker,
    summaryPopup,
    summarizePopup,
    citationPopup,
    bookmarkUrls,
  } = useSelector((state) => state.data);

  const getBookmarks = async (id) => {
    const res = await axiosInstance.post(
      searchAPI.getCollectionsSource,
      {
        callingUserId: user.userId,
        collectionId: id,
      },
      getConfig()
    );
    res.data && setBookmarks(res.data);
    setFilteredBookmarks(res.data);
    if (search) {
      getSearchedBookmarks();
      handleSearchChange();
    } else if (searchFromBookmarks) {
      handleBookmarkSearch(searchFromBookmarks, res.data);
    }
    setParent(res.data.parentCollectionID_lng);
    setHeaderParams((prevHeaderParams) => ({
      ...prevHeaderParams,
      length: res.data.length,
    }));
  };

  const getSearchedBookmarks = async () => {
    const res = await axiosInstance.post(
      searchAPI.getCollectionsSource,

      {
        filter: "",
        userId: user.userId,
        callingUserId: user.userId,
      },

      getConfig()
    );
    setSearchedBookmark(res.data);
    setLoading(false);
  };

  const deleteBookmark = async (id) => {
    await axiosInstance.delete(searchAPI.deleteCollections, {
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
      data: {
        callingUserId: user.userId,
        collectionId: id,
        isHardDelete: false,
      },
    });
    const searchParams = new URLSearchParams(location.search);
    const search = searchParams.get("search");
    navigate(`/saved/0${search ? `?search=${search}` : ""}`);
    setDarkBackground(false);
  };

  const deleteBookmarkSource = async (id) => {
    await axiosInstance.delete(searchAPI.deleteCollectionsSource, {
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
      data: {
        callingUserId: user.userId,
        collectionSourceId: id,
        isHardDelete: false,
      },
    });
  };

  const handleDeleteBookmark = (id) => {
    deleteBookmarkSource(id);
    setBookmarks(
      bookmarks.filter((bookmark) => bookmark.collectionSourceID_ids !== id)
    );
    setFilteredBookmarks(
      filteredBookmarks.filter(
        (bookmark) => bookmark.collectionSourceID_ids !== id
      )
    );
  };

  const isEmpty = (obj) => Object.keys(obj).length === 0;

  const handleSearchChange = () => {
    setSearchFromBookmarks("");
    const searchParams = new URLSearchParams(location.search);
    const search = searchParams.get("search").trim();

    if (!search || isEmpty(searchedBookmark)) return;
    const filteredBookmarks = searchedBookmark.filter(
      (bookmark) =>
        bookmark.title_chr.toLowerCase().includes(search.toLowerCase()) ||
        bookmark.sourceName_chr.toLowerCase().includes(search.toLowerCase())
    );
    setFilteredBookmarks(filteredBookmarks);
  };

  const handleBookmarkSearch = (search, data) => {
    setSearchFromBookmarks(search);
    const filteredBookmarks = data.filter(
      (bookmark) =>
        bookmark.title_chr.toLowerCase().includes(search.toLowerCase()) ||
        bookmark.sourceName_chr.toLowerCase().includes(search.toLowerCase())
    );
    setFilteredBookmarks(filteredBookmarks);
  };

  const handleChange = (search) => {
    setSearchFromBookmarks(search);
    const filteredBookmarks = bookmarks.filter(
      (bookmark) =>
        bookmark.title_chr.toLowerCase().includes(search.toLowerCase()) ||
        bookmark.sourceName_chr.toLowerCase().includes(search.toLowerCase())
    );
    setFilteredBookmarks(filteredBookmarks);
  };

  const redirectAndSetHeaderParams = (res) => {
    const searchParams = new URLSearchParams(location.search);
    const search = searchParams.get("search");
    Number(params.id) === 0 &&
      navigate(
        `/saved/${res.data[0].collectionID_ids}${
          search ? `?search=${search}` : ""
        }`
      );
    if (Number(params.id) === 0) {
      setHeaderParams((prevHeaderParams) => ({
        ...prevHeaderParams,
        created: res.data[0].createdDateTime_dtm,
        updated: res.data[0].lastUpdatedDateTime_dtm,
        title: res.data[0].collectionName_chr,
        isShared_ysn: res.data[0].isShared_ysn,
      }));
      navigate(
        `/saved/${res.data[0].collectionID_ids}${
          search ? `?search=${search}` : ""
        }`
      );
    } else {
      const item = res.data.find(
        (item) => item.collectionID_ids === Number(params.id)
      );
      if (item) {
        setHeaderParams((prevHeaderParams) => ({
          ...prevHeaderParams,
          created: item.createdDateTime_dtm,
          updated: item.lastUpdatedDateTime_dtm,
          title: item.collectionName_chr,
          isShared_ysn: item.isShared_ysn,
        }));
      }
    }
  };

  const getParentCollectionIds = (res) => {
    const ids = res.data
      .filter((collection) => collection.parentCollectionID_lng === 0)
      .map((collection) => collection.collectionID_ids);
    setParentCollectionIds(ids);
  };

  const getData = async () => {
    const res = await axiosInstance.post(
      searchAPI.getCollections,
      {
        callingUserId: user.userId,
        userId: user.userId,
      },
      getConfig()
    );
    setCollections(res.data);
    getParentCollectionIds(res);
    redirectAndSetHeaderParams(res);
    setLoading(false);
  };

  const handleSaveCitation = () => {
    console.log(id);
    setBookmarks((prev) =>
      prev.map((bookmark) => {
        if (bookmark.collectionSourceID_ids === id) {
          return {
            ...bookmark,
            isCitationAvailable_ysn: true,
          };
        }
        return bookmark;
      })
    );
  };

  const saveCollectionFolder = async (name) => {
    let parent = {};
    if (subNewFolder) {
      parent = { parentCollectionId: params.id };
    }
    const requestsData = {
      callingUserId: user.userId,
      userId: user.userId,
      collectionName: name,
      ...parent,
    };
    const { data } = await axiosInstance.post(
      searchAPI.updateCollections,
      requestsData,
      getConfig()
    );
    if (
      data === "Error: Cannot add more than 2 nested levels of collections."
    ) {
      toast.error("Sorry! You can't create more than 2 subfolders.");
      setSubNewFolder(false);
      setShowPopup(false);
      return;
    }
    getData();
    toast.success("Collection created successfully.");
    setSubNewFolder(false);
    setShowPopup(false);
  };

  const removeSharedUser = async (id, email) => {
    try {
      const requestsData = {
        collectionId: params.id,
        sharedWithUserId: id,
        callingUserId: user.userId,
        sharedWithEmailId: email,
      };
      const res = await axiosInstance.post(
        searchAPI.removeSharedUser,
        requestsData,
        getConfig()
      );
      toast.success("Shared User access removed successfully.");
      getData();
      setShowPopup(false);
      setUserPopup(false);
      setDarkBackground(false);
    } catch (error) {
      if (error.response.status === 500) {
        toast.error(
          `Unable to delete ${email} from shared collection. Kindly Contact admin for further support.`
        );
      }
    }
  };

  const renameCollection = async (name) => {
    try {
      const requestsData = {
        callingUserId: user.userId,
        userId: user.userId,
        collectionId: params.id,
        collectionName: name,
      };
      await axiosInstance.post(
        searchAPI.updateCollections,
        requestsData,
        getConfig()
      );
      getData();
      setRenamePopup(false);
      setDarkBackground(false);
      toast.success("Collection renamed successfully.");
    } catch {
      toast.error("Some error occured while renaming the collection.");
    }
  };

  const shareCollectionFolder = async (emailList) => {
    try {
      const requestsData = {
        collectionId: params.id,
        userId: user.userId,
        email: emailList,
      };
      await axiosInstance.post(
        searchAPI.shareCollections,
        requestsData,
        getConfig()
      );
      toast.success("Collection shared successfully.");
      getData();
      setSharePopup(false);
      setDarkBackground(false);
    } catch (error) {
      console.log(error.response.status);
      setDarkBackground(false);

      if (error.response.status === 500) {
        toast.error("This Colelctions is already being shared with the user");
      }
      if (error.response.data === "Recipient Not Found") {
        toast.error("User not found!");
      }
    }
  };

  function handleEnterKey(event) {
    if (event.key === "Enter") {
      handleChange(event.target.value);
    }
  }

  const handleDelete = () => {
    setDeletePopup((prev) => !prev);
    logEvent("deletePopup", { bookmark: params.id });
    setDarkBackground(true);
  };

  const handleSavedCitation = async (authors) => {
    try {
      const json_res = {
        ...articleData,
        creators: authors,
        collectionSourceId: id,
        userId: user.userId,
        citation: citation,
      };
      const res = await axiosInstance.post(
        searchAPI.saveCitation,
        json_res,
        getConfig()
      );
      getBookmarks(params.id);
      dispatch(setCitationPopup(false));
      toast.success("Citation saved successfully!");
      if (id) {
        handleSaveCitation();
      }
    } catch (e) {
      console.log(e);
    }
  };

  const getCollArray = async () => {
    try {
      const { data } = await axiosInstance.post(
        searchAPI.getParentChainCollection,
        {
          collectionId: params.id,
          userId: user.userId,
        },
        getConfig()
      );
      setCollectionIdArray(data);
    } catch (e) {
      console.log(e);
    }
  };

  const checkParent = () => {
    const current = collections.filter(
      (collection) => collection.collectionID_ids === Number(params.id)
    );
    if (!current.length) return false;
    if (!current[0].parentCollectionID_lng) return true;
    return false;
  };

  const sortFilteredUsers = (col, toSort) => {
    let arr;
    if (
      col === "sourceName_chr" ||
      col === "title_chr" ||
      col === "collectionName_chr"
    ) {
      if (toSort) {
        arr = [...filteredBookmarks].sort(function (a, b) {
          return a[col].toLowerCase() < b[col].toLowerCase() ? 1 : -1;
        });
      } else {
        arr = [...filteredBookmarks].sort(function (a, b) {
          return a[col].toLowerCase() < b[col].toLowerCase() ? -1 : 1;
        });
      }
    } else if (
      col === "sourcePublishedDateTime_dtm" ||
      col === "lastUpdatedDateTime_dtm"
    ) {
      if (toSort) {
        arr = [...filteredBookmarks].sort(function (a, b) {
          var dateA = new Date(a[col]).getTime();
          var dateB = new Date(b[col]).getTime();
          return dateA < dateB ? 1 : -1;
        });
      } else {
        arr = [...filteredBookmarks].sort(function (a, b) {
          var dateA = new Date(a[col]).getTime();
          var dateB = new Date(b[col]).getTime();
          return dateA < dateB ? -1 : 1;
        });
      }
    } else {
      arr = filteredBookmarks;
    }
    setFilteredBookmarks(arr);
  };

  useEffect(() => {
    if (search) {
      handleSearchChange();
    }
  }, [search, searchedBookmark]);

  useEffect(() => {
    getCollArray();
    getData();
    const searchParams = new URLSearchParams(location.search);
    const search = searchParams.get("search");
    if (!search) {
      console.log("");
      getBookmarks(params.id);
    }
  }, [params.id]);

  useEffect(() => {
    getSearchedBookmarks();
  }, []);

  return loading ? (
    <div className="circular-loader-center">
      <CustomLoader />
    </div>
  ) : (
    <div className="saved-page">
      {darkBackground && <div className="bg-dark" />}
      <div
        className={`bg-dark-collection hd-ds ${
          sidebarColActive ? "active" : ""
        }`}
        onClick={() => setSidebarColActive(false)}
      />
      {collectionIdArray && (
        <SidebarCollection
          sidebarColActive={sidebarColActive}
          data={collections}
          parent={parent}
          setHeaderParams={setHeaderParams}
          setShowPopup={setShowPopup}
          collectionIdArray={collectionIdArray}
          setSubNewFolder={setSubNewFolder}
          parentCollectionIds={parentCollectionIds}
          headerParams={headerParams}
          search={search}
          setSearch={setSearch}
        />
      )}
      <div className="right">
        {!search && (
          <TopHeader
            setSidebarColActive={setSidebarColActive}
            headerParams={headerParams}
            setDarkBackground={setDarkBackground}
            setCustomBookmarkPopup={setCustomBookmarkPopup}
            setUserPopup={setUserPopup}
            setRenamePopup={setRenamePopup}
            checkParent={checkParent}
            setSharePopup={setSharePopup}
            handleDelete={handleDelete}
          />
        )}
        <div className={`middle-sec ${search ? "no-border" : ""}`}>
          <ShareBookmark
            sharePopup={sharePopup}
            setSharePopup={setSharePopup}
            shareCollectionFolder={shareCollectionFolder}
            setDarkBackground={setDarkBackground}
          />
          <RenameCollection
            renamePopup={renamePopup}
            setRenamePopup={setRenamePopup}
            renameCollection={renameCollection}
            setDarkBackground={setDarkBackground}
          />
          <SharedList
            userPopup={userPopup}
            setUserPopup={setUserPopup}
            shareCollectionFolder={shareCollectionFolder}
            deleteSharedUser={removeSharedUser}
            setDarkBackground={setDarkBackground}
          />
          {!search && (
            <BottomHeader
              headerParams={headerParams}
              length={
                search || searchFromBookmarks
                  ? filteredBookmarks.length
                  : bookmarks.length
              }
              handleEnterKey={handleEnterKey}
              handleChange={handleChange}
            />
          )}
        </div>
        <Table
          bookmarks={
            search || searchFromBookmarks ? filteredBookmarks : bookmarks
          }
          handleDeleteBookmark={handleDeleteBookmark}
          setShowSummarizePopup={setShowSummarizePopup}
          setSummary={setSummary}
          setBookmark={setBookmark}
          setId={setId}
          setCitationAvailable={setCitationAvailable}
          setSummarizePopupNa={setSummarizePopupNa}
          getBookmarks={getBookmarks}
          setFilteredBookmarks={setFilteredBookmarks}
          search={search}
          setSearch={setSearch}
          sortFilteredUsers={sortFilteredUsers}
          searchFromBookmarks={searchFromBookmarks}
          setBookmarks={setBookmarks}
          setDarkBackground={setDarkBackground}
        />
        {datePicker && <Datepicker />}
        <NewBookmark
          newBookmarkPopup={showPopup}
          setNewBookmarkPopup={setShowPopup}
          saveCollectionFolder={saveCollectionFolder}
          setSubNewFolder={setSubNewFolder}
          subNewFolder={subNewFolder}
          title={headerParams.title}
        />
        <DeleteBookmark
          deletePopup={deletePopup}
          setDeletePopup={setDeletePopup}
          deleteBookmark={deleteBookmark}
          id={params.id}
          setDarkBackground={setDarkBackground}
        />
        {summarizePopup && summarizePopupNa && (
          <Summarize
            setSaveBookmarkPopup={setSaveBookmarkPopup}
            id={id}
            desc={desc}
            setDesc={setDesc}
            isDescExternal={isDescExternal}
            setIsDescExternal={setIsDescExternal}
            setSummaryText={setSummaryText}
            summaryText={summaryText}
            summarizePopupNa={summarizePopupNa}
            setSummarizePopupNa={setSummarizePopupNa}
            getBookmarks={getBookmarks}
            bookmark={bookmark}
          />
        )}
        {summaryPopup && (
          <CustomSummarize
            setDesc={setDesc}
            setIsDescExternal={setIsDescExternal}
            setSummarizePopupNa={setSummarizePopupNa}
            setSummaryText={setSummaryText}
            summaryText={summaryText}
          />
        )}
        <UpdateSummary
          showPopup={showSummarizePopup}
          setShowPopup={setShowSummarizePopup}
          summary={summary}
          setSummary={setSummary}
          bookmark={bookmark}
          getBookmarks={getBookmarks}
        />
        <PopupSave
          data={bookmark}
          bookmarkUrls={bookmarkUrls}
          handleDataFetch={() => {}}
          setNewBookmarkPopup={setShowPopup}
          selectedCollection={selectedCollection}
          setselectedCollection={setselectedCollection}
          popup={saveBookmarkPopup}
          setpopup={setSaveBookmarkPopup}
          getBookmarks={getBookmarks}
          desc={desc}
          setData={setBookmark}
          id={id}
        />
        {citationPopup && (
          <PopupCitation
            collectionIdid={id}
            handleSaveCitation={handleSaveCitation}
            citationAvailable={citationAvailable}
            setCitationAvailable={setCitationAvailable}
            handleSavedCollection={handleSavedCitation}
            articleData={articleData}
            setArticleData={setArticleData}
            citation={citation}
            setCitation={setCitation}
            setBookmarkData={setBookmark}
          />
        )}
        <CustomBookmark
          getBookmarks={getBookmarks}
          setCustomBookmarkPopup={setCustomBookmarkPopup}
          title={headerParams.title}
          setDarkBackground={setDarkBackground}
          customBookmarkPopup={customBookmarkPopup}
        />
      </div>
    </div>
  );
};

export default SavedPage;
